import React from 'react';
import PropTypes from 'prop-types';
import { Card, CardContent } from '@ferris/react/components/cards';
import { TrackingContext } from '@vrbo/react-event-tracking';
import EgHeader from '../../EgHeader';
import EgFooter from '../../EgFooter';

class MvpTemplate extends React.Component {
    // eslint-disable-next-line react/sort-comp
    static contextType = TrackingContext;

    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        const {
            children,
            history,
            referrer
        } = this.props;

        return (
            <div className="ulx-antialias mvp-content-container">
                <EgHeader history={history} referrer={referrer} />
                <div className="ulx-mvp-container" id="cl-list-your-property-form">
                    <Card
                        elevation="0"
                        theme="default"
                    >
                        <CardContent
                            collapsePadding={false}
                            separatorBottom={false}
                            separatorTop={false}
                        >
                            {children}
                        </CardContent>
                    </Card>
                </div>
                <EgFooter />
            </div>
        );
    }
}

MvpTemplate.propTypes = {
    children: PropTypes.oneOfType([
        PropTypes.array,
        PropTypes.object
    ]).isRequired,
    history: PropTypes.shape({
        replace: PropTypes.func,
        location: PropTypes.shape({
            pathname: PropTypes.string
        }).isRequired
    }).isRequired,
    referrer: PropTypes.string.isRequired
};

export default MvpTemplate;
